import { render, staticRenderFns } from "./bargainSetting.vue?vue&type=template&id=8f5e3914&scoped=true&"
import script from "./bargainSetting.vue?vue&type=script&lang=js&"
export * from "./bargainSetting.vue?vue&type=script&lang=js&"
import style0 from "./bargainSetting.vue?vue&type=style&index=0&id=8f5e3914&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e3914",
  null
  
)

export default component.exports